import { render, staticRenderFns } from "./dutch-laravel-foundation.vue?vue&type=template&id=3f14f2a8&"
import script from "./dutch-laravel-foundation.vue?vue&type=script&lang=js&"
export * from "./dutch-laravel-foundation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports